exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vYODHyphAwZ3TKb3ITDvl {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.vYODHyphAwZ3TKb3ITDvl h2 {\n  color: var(--gray-dark) !important;\n  font-weight: 400 !important;\n  font-style: normal;\n  margin-bottom: 1.5rem !important;\n  font-size: 0.875rem !important;\n}\n.vYODHyphAwZ3TKb3ITDvl > div {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.TgB0OywI9hUhVsqZJP1fJ {\n  margin-bottom: 1rem !important;\n}\n._2A9asZF3tlNxuKpowwC1Gm > p:first-child {\n  font-weight: 600;\n}\n._2A9asZF3tlNxuKpowwC1Gm p {\n  margin: 0!important;\n}\n.Bjra1EMkKbtj82TyHCKU6 {\n  margin-left: 1rem;\n  color: var(--green);\n}\n", ""]);

// exports
exports.locals = {
	"container": "vYODHyphAwZ3TKb3ITDvl",
	"vInfo": "TgB0OywI9hUhVsqZJP1fJ",
	"versionBtn": "_2A9asZF3tlNxuKpowwC1Gm",
	"selected": "Bjra1EMkKbtj82TyHCKU6"
};